import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { pushOperator, pushShowCalendar, pushSearchLoader, pushTablePageCount, pushTableRowCount, pushTableTotalCount, pushStatus, pushSelectedChipArray, resetBodySearch } from '../../slices/customQueryBodySlice';
import { ButtonGroup, makeStyles } from '@material-ui/core';
import { pushAPIData, pushSelectedData, resetSearchData, setSearchString } from '../../slices/customQuerySlice';
import consts from '../../utils/consts';
import { getResponseAPIData, getPostResponseAPIData } from '../../services/apiService';
import Button from '@material-ui/core/Button';
import styled from 'styled-components';
import { pushPostApiResponse, pushgetApiResponse } from '../../slices/customQueryHeaderSlice';
const StyledOperationsButton = styled(Button)`
  &.MuiButton-root {
    color: rgba(0, 0, 0, 0.69);
    font-family: 'OpenSans-Regular';
    font-size: 13px !important;
    letter-spacing: 0 !important;
    text-align: left !important;
    text-transform: capitalize !important;
    background-color: ${props => props.active ? '#EFF3F8' : '#fff'};
    border: none;
    justify-content: flex-start !important;
  }
`;
const useStyles = makeStyles(() => ({
  direction: {
    flexDirection: 'column',
    width: '100%'
  }
}));

const OperationsCard = props => {
  let {
    userAccountOperations,
    requestbody,
    baseUrl,
    paginationString,
    entityNames,
    baseUrlquery,
    paginationStringQuery
  } = consts;
  let active = useSelector(state => state.customQueryBody.active);
  const [currentIndex, setIndex] = React.useState(0);
  const operationsCardButtonNames = useSelector(state => state.operations.operationsNamesArray);
  const {
    setInputText
  } = props;
  const postApiResponse = useSelector(state => state.customQueryHeader.postCustomQuery);
  const dataItem = useSelector(state => state.customQuery.dataItem);
  const classes = useStyles();
  const dispatch = useDispatch();
  useEffect(() => {
    if (postApiResponse && postApiResponse[0]?.data) {
      let datafetch = [];
      let dataItemList = dataItem.recordType;
      let dataExists = '';

      if (dataItemList === 'applications' || dataItemList === 'environments') {
        if (postApiResponse[0].data.applicationDetails && postApiResponse[0].data.applicationDetails.length > 0) {
          dataExists = postApiResponse[0].data.applicationDetails;
          datafetch.push({
            data: postApiResponse[0].data.applicationDetails,
            type: 'applications'
          });
        } else if (postApiResponse[0].data.environmentDetails && postApiResponse[0].data.environmentDetails.length > 0) {
          dataExists = postApiResponse[0].data.environmentDetails;
          datafetch.push({
            data: postApiResponse[0].data.environmentDetails,
            type: 'environments'
          });
        }
      } else {
        entityNames.forEach(urlEntityName => {
          dataExists = postApiResponse[0].data.queryData;
          datafetch.push({
            data: postApiResponse[0].data.queryData,
            type: urlEntityName === 'userAccounts' ? 'user accounts' : urlEntityName
          });
        });
      }

      dispatch(pushAPIData(datafetch));
      dispatch(pushSelectedData(dataItem));

      if (dataExists && dataExists.length > 0) {
        dispatch(pushSearchLoader(false));
      }
    }
  }, [postApiResponse]);
  return /*#__PURE__*/React.createElement(ButtonGroup, {
    vertical: true,
    className: classes.direction
  }, operationsCardButtonNames.map((operationsCardButtonName, index) => {
    return /*#__PURE__*/React.createElement(StyledOperationsButton, {
      key: index,
      name: operationsCardButtonName,
      active: active ? currentIndex === index ? true : false : false,
      onClick: event => {
        let {
          name
        } = event.currentTarget;
        let dataItemList = dataItem.recordType;
        let riskEntityCheck = dataItem.keyName.toLowerCase();
        dispatch(setSearchString(''));

        if (name === 'is' && !riskEntityCheck.includes('risk')) {
          dispatch(pushTablePageCount(''));
          dispatch(pushTableRowCount(''));
          dispatch(pushTableTotalCount(''));
          let searchdata = {
            data: '',
            type: 'search'
          };
          dispatch(pushgetApiResponse(searchdata));
          let data = {
            data: '',
            type: 'postCustomQuery'
          };
          dispatch(pushgetApiResponse(data));
          let savedata = {
            data: '',
            type: 'postCustomQuery'
          };
          dispatch(pushPostApiResponse(savedata));
          dispatch(resetSearchData());
          let localBaseUrl = baseUrl;
          let paginationQueryString = paginationString + 1;
          dispatch(pushSearchLoader(true));
          dispatch(resetBodySearch());
          let urlEntityName = dataItemList === 'user accounts' ? 'useraccount' : dataItemList.substring(0, dataItemList.length - 1);
          let urls = localBaseUrl + urlEntityName.toLowerCase() + paginationQueryString;

          if (dataItemList === 'applications' || dataItemList === 'environments') {
            let appurl = baseUrlquery + dataItemList + paginationStringQuery;
            dispatch(getResponseAPIData([appurl], 'postCustomQuery'));
          } else {
            dispatch(getPostResponseAPIData([urls], requestbody, 'postCustomQuery'));
          }
        }

        dispatch(pushOperator(name));
        dispatch(pushShowCalendar(userAccountOperations.includes(name)));
        dispatch(pushStatus(true));
        setIndex(index);
        setInputText('');
        dispatch(pushSelectedChipArray([]));
      },
      variant: "light"
    }, operationsCardButtonName);
  }));
};

export default OperationsCard;